import _get from "/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/helpers/esm/get.js";
import _classCallCheck from "/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { StreamCipher } from './cipher-core.js';

function generateKeystreamWord() {
  // Shortcuts
  var S = this._S;
  var i = this._i;
  var j = this._j; // Generate keystream word

  var keystreamWord = 0;

  for (var n = 0; n < 4; n += 1) {
    i = (i + 1) % 256;
    j = (j + S[i]) % 256; // Swap

    var t = S[i];
    S[i] = S[j];
    S[j] = t;
    keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
  } // Update counters


  this._i = i;
  this._j = j;
  return keystreamWord;
}
/**
 * RC4 stream cipher algorithm.
 */


export var RC4Algo = /*#__PURE__*/function (_StreamCipher) {
  _inherits(RC4Algo, _StreamCipher);

  var _super = _createSuper(RC4Algo);

  function RC4Algo() {
    _classCallCheck(this, RC4Algo);

    return _super.apply(this, arguments);
  }

  _createClass(RC4Algo, [{
    key: "_doReset",
    value: function _doReset() {
      // Shortcuts
      var key = this._key;
      var keyWords = key.words;
      var keySigBytes = key.sigBytes; // Init sbox

      this._S = [];
      var S = this._S;

      for (var i = 0; i < 256; i += 1) {
        S[i] = i;
      } // Key setup


      for (var _i = 0, j = 0; _i < 256; _i += 1) {
        var keyByteIndex = _i % keySigBytes;
        var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;
        j = (j + S[_i] + keyByte) % 256; // Swap

        var t = S[_i];
        S[_i] = S[j];
        S[j] = t;
      } // Counters


      this._j = 0;
      this._i = this._j;
    }
  }, {
    key: "_doProcessBlock",
    value: function _doProcessBlock(M, offset) {
      var _M = M;
      _M[offset] ^= generateKeystreamWord.call(this);
    }
  }]);

  return RC4Algo;
}(StreamCipher);
RC4Algo.keySize = 256 / 32;
RC4Algo.ivSize = 0;
/**
 * Shortcut functions to the cipher's object interface.
 *
 * @example
 *
 *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
 *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
 */

export var RC4 = StreamCipher._createHelper(RC4Algo);
/**
 * Modified RC4 stream cipher algorithm.
 */

export var RC4DropAlgo = /*#__PURE__*/function (_RC4Algo) {
  _inherits(RC4DropAlgo, _RC4Algo);

  var _super2 = _createSuper(RC4DropAlgo);

  function RC4DropAlgo() {
    var _this;

    _classCallCheck(this, RC4DropAlgo);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super2.call.apply(_super2, [this].concat(args));
    /**
     * Configuration options.
     *
     * @property {number} drop The number of keystream words to drop. Default 192
     */

    Object.assign(_this.cfg, {
      drop: 192
    });
    return _this;
  }

  _createClass(RC4DropAlgo, [{
    key: "_doReset",
    value: function _doReset() {
      _get(_getPrototypeOf(RC4DropAlgo.prototype), "_doReset", this).call(this); // Drop


      for (var i = this.cfg.drop; i > 0; i -= 1) {
        generateKeystreamWord.call(this);
      }
    }
  }]);

  return RC4DropAlgo;
}(RC4Algo);
/**
 * Shortcut functions to the cipher's object interface.
 *
 * @example
 *
 *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
 *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
 */

export var RC4Drop = StreamCipher._createHelper(RC4DropAlgo);